import { schema } from "normalizr";
import { gameEntity } from "./game";

export const playerEntity = new schema.Entity("players", {
  gameId: gameEntity,
});
